<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal" @click.stop>
      <div class="modal-header">
        <h3 class="modal-title">Contactez-nous</h3>
        <button type="button" class="modal-close" @click="closeModal">
          <span>&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
        <div class="contact-info">
          <div class="contact-section">
            <h4>Service client</h4>
            <p>Pour toutes les questions concernant les commandes et les expéditions</p>
            <div class="contact-details">
              <p><strong>Téléphone :</strong> 01 53 27 91 08</p>
              <p><strong>Email :</strong> service@efashion-paris.com</p>
            </div>
          </div>
          
          <div class="qr-section">
            <div class="qr-item">
              <div class="qr-info">
                <h5>Service client</h5>
                <img
                  :src="serviceWechatQr"
                  alt="QR code WeChat Service client"
                  class="w-full max-w-[220px] mx-auto rounded"
                >
              </div>
            </div>

            <div class="qr-item">
              <div class="qr-info">
                <h5>Bryan - CEO</h5>
                <img
                  :src="bryanWechatQr"
                  alt="QR code WeChat Bryan Chen"
                  class="w-full max-w-[220px] mx-auto rounded"
                >
              </div>
            </div>

            <div class="qr-item">
              <div class="qr-info">
                <h5>Liu - Relation grossiste</h5>
                <img
                  :src="liuWechatQr"
                  alt="QR code WeChat Liu"
                  class="w-full max-w-[220px] mx-auto rounded"
                >
              </div>
            </div>

            <div class="qr-item">
              <div class="qr-info">
                <h5>Tiphaine - Studio photo</h5>
                <img
                  :src="tiphaineWechatQr"
                  alt="QR code WeChat Tiphaine"
                  class="w-full max-w-[220px] mx-auto rounded"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="modal-btn btn-danger" @click="closeModal">
          Fermer
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, watch } from 'vue'
import serviceWechatQr from '@/assets/images/service-wechat.jpg'
import bryanWechatQr from '@/assets/images/bryan-wechat.jpg'
import liuWechatQr from '@/assets/images/liu-wechat.jpg'
import tiphaineWechatQr from '@/assets/images/tiphaine-wechat.jpg'

interface Props {
  isVisible: boolean
}

interface Emits {
  (e: 'update:isVisible', value: boolean): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const closeModal = () => {
  emit('update:isVisible', false)
}

const initialBodyOverflow = document.body.style.overflow

watch(
  () => props.isVisible,
  (isVisible) => {
    document.body.style.overflow = isVisible ? 'hidden' : initialBodyOverflow
  },
  { immediate: true }
)

onUnmounted(() => {
  document.body.style.overflow = initialBodyOverflow
})
</script>
